<!--
    file type .....: HTML file: globalsearch.component.html
    Created By ....: ianday
    Date ..........: 8/28/23 
-->
<div class="globalsearch-container" >
    <!-- query criteria -->
    <div style="height: 330px;padding:5px;background-color:whitesmoke">
        <div class="dwform" style="padding-right:15px;">
            <!-- first row -->
            <div  style="width: 1085px;">
                <!-- first name -->
                <div style="display: inline-block;width:33%; text-align: left">
                    <label class="label-field-override">First Name:</label>
                    <span class="form-required"> </span>
                    <input mat-input [disabled]="disabledFlag"
                           matTooltip="First (Christian) Name"
                           placeholder="<Member's First Name>"
                           id="memberNameParamId"
                           class="input-field-short" style="width:200px;"
                           [(ngModel)]="searchQBE.memberFirstName">
                </div>
                <div style="display: inline-block; width:33%; text-align: left">
                    <label class="label-field-override">Last Name:</label>
                    <span class="form-required"> </span>

                    <input mat-input [disabled]="disabledFlag"
                           matTooltip="Last Name"
                           placeholder="<Member's Last Name>"
                           class="input-field-short" style="width:200px;"
                           [(ngModel)]="searchQBE.memberLastName">
                </div>
                <div style="display: inline-block; width:33%; text-align: left" *ngIf="showDateOfBirth">
                    <span style="margin-right: 20px;">Date of Birth:</span>
                    <input matInput [disabled]="disabledFlag"
                           id="memberDateOfBirthId"
                           style="width: 90px"
                           mask="9999-99-99"
                           showMaskTyped="true"
                           [dropSpecialCharacters]="false"
                           class="input-field-short"
                           matTooltip="Format: YYYY-MM-DD"
                           [(ngModel)]="searchQBE.memberDateOfBirth">
                </div>
            </div>

            <!-- second row -->
            <div class="dwform-row-gap"></div>
            <div  style="width: 1085px;">
                <!-- first name -->
                <div style="display: inline-block;width:33%; text-align: left">
                    <label class="label-field-override">Relationship:</label>
                    <span class="form-required"> </span>

                    <input mat-input [disabled]="disabledFlag"
                           matTooltip="Relationship"
                           placeholder="<Member's Relationship>"
                           class="input-field-short" style="width:200px;"
                           [(ngModel)]="searchQBE.memberRelationship">
                </div>
                <div style="display: inline-block;width:33%; text-align: left">
                    <span style="margin-right: 20px;">Date Added:</span>
                    <input matInput [disabled]="disabledFlag" style="width: 90px"
                           id="dateAddedId"
                           mask="9999-99-99"
                           showMaskTyped="true"
                           [dropSpecialCharacters]="false"
                           class="input-field-short"
                           matTooltip="Format: YYYY-MM-DD"
                           [(ngModel)]="searchQBE.memberDateAdded">
                </div>
                <div style="display: inline-block;width:33%; text-align: left">
                    <label class="label-field-override">Telephone:</label>
                    <span class="form-required"> </span>

                    <input matInput class="input-field-short" id="phoneNumber"
                           [dropSpecialCharacters]="false"
                           showMaskTyped="true"
                           mask="(999) 999-9999"
                           [disabled]="disabledFlag"
                           [(ngModel)]="searchQBE.phoneNumber"
                           placeholder="<Telephone>"
                           type="text"/>
                </div>
            </div>
            <div class="dwform-row-double-gap"></div>
            <!-- third row -->
            <div  style="width: 1085px;">
                <!-- first name -->
                <div style="display: inline-block;width:33%; text-align: left">
                    <label class="label-field-override">Case Number:</label>
                    <span class="form-required"> </span>

                    <input mat-input [disabled]="disabledFlag"
                           matTooltip="Enter a case number (or part of a case number)"
                           placeholder="<Case Number>"
                           class="input-field-short"
                           [(ngModel)]="searchQBE.caseNumber">

                </div>
                <div style="display: inline-block;width:33%; text-align: left">
                    <label class="label-field-override">First Name:</label>
                    <span class="form-required"> </span>

                    <input mat-input [disabled]="disabledFlag"
                           matTooltip="First (Christian) Name"
                           placeholder="<Applicant's First Name>"
                           class="input-field-short" style="width:200px;"
                           [(ngModel)]="searchQBE.firstName">
                </div>
                <div style="display: inline-block;width:33%; text-align: left">
                    <label class="label-field-override">Last Name:</label>
                    <span class="form-required"> </span>
                    <input mat-input [disabled]="disabledFlag"
                           matTooltip="Last name or given name"
                           placeholder="<Applicant's Last Name>"
                           class="input-field" style="width:200px;"
                           [(ngModel)]="searchQBE.lastName">
                </div>
            </div>

            <div class="dwform-row-gap"></div>

            <div style="display: inline-block;width:100%;
                vertical-align: top;">
                <div style="display: inline-block; width:65%; ">
                    <!-- forth row -->
                    <div  style="width: 700px;">
                        <!-- first name -->
                        <div style="display: inline-block;width:100%; text-align: left" *ngIf="showUnlimitedAgencyfilter">
                            <label class="label-field-override">Agency:</label>
                            <span class="form-required"> </span>

                            <input mat-input [disabled]="disabledFlag"
                                   matTooltip="Enter an agency name or part or an agency name"
                                   placeholder="<Agency Name>"
                                   class="input-field" style="width: 200px;"
                                   [(ngModel)]="searchQBE.agencyName">
                        </div>

                    </div>

                    <div class="dwform-row-gap"> </div>
                    <!-- fifth row -->
                    <div  style="width: 700px;">
                        <!-- first name -->
                        <div style="display: inline-block;width:48%; text-align: left">

                            <label class="label-field-override">Use Date:</label>
                            <span class="form-required"> </span>

                            <dw-dropdown
                                    [controlWidth]="'200px'"
                                    [dataSource]="useDateRecs"
                                    [selectedItem]="searchQBE.useDate"
                                    (itemSelected)="searchQBE.useDate = $event">
                            </dw-dropdown>
                        </div>
                        <div style="display: inline-block;width:50%; text-align: left">
                            <span style="margin-right: 60px;">From:</span>
                            <input mat-input [disabled]="disabledFlag"
                                   id="dateFromId"
                                   style="width: 90px"
                                   mask="9999-99-99"
                                   showMaskTyped="true"
                                   [dropSpecialCharacters]="false"
                                   class="input-field-short"
                                   matTooltip="Format: YYYY-MM-DD"
                                   [(ngModel)]="searchQBE.dateFrom">
                            <span class="form-required"> </span>
                            <span style="margin-left: 0px;margin-right: 5px;">To:</span>
                            <input matInput [disabled]="disabledFlag" style="width: 90px"
                                   id="dateToId"
                                   mask="9999-99-99"
                                   showMaskTyped="true"
                                   [dropSpecialCharacters]="false"
                                   class="input-field-short"
                                   matTooltip="Format: YYYY-MM-DD"
                                   [(ngModel)]="searchQBE.dateTo">
                        </div>
                    </div>
                    <div class="dwform-row-gap"> </div>
                    <div style="display: inline-block; width:48%; text-align: left;margin-top: 5px" *ngIf="showPossibleDuplicated">
                            <label class="label-field-override">
                                <mat-checkbox labelPosition="before" matTooltip="Show records that require duplicate treatment"
                                    [(ngModel)]="searchQBE.showPossibleDuplicates">Possible Duplicates:</mat-checkbox>
                            </label>
                        </div>
                </div>

                <div style="display: inline-block; vertical-align:top; width:34%; ">
                    <div style="display: inline-block; vertical-align: top;">
                        <label class="label-field-override" style="
                        padding-top: 8px;padding-left: 7px;width: 110px;">Status:</label>
                    </div>
                    <div style="display: inline-block; vertical-align:top;">
                        <mat-selection-list #shoes class="status-container" [disabled]="disabledFlag">
                            <ng-container *ngFor="let status of caseStatusList">
                                <mat-list-option>
                                    <mat-checkbox [ngModel]="status.isSelected" style="scale: 93%"
                                                  (ngModelChange)="status.isSelected = $event">
                                        {{ status.shortDescription }}
                                    </mat-checkbox>
                                </mat-list-option>
                            </ng-container>
                        </mat-selection-list>
                    </div>
                </div>
             </div>
    </div>

    <!-- Clear / Search Strip -->
     <div style="display: inline-block; width: 33%;color: lightcoral;">
        {{this.maxWarn}}
    </div>
    <div style="display: inline-block; text-align:center; width: 33%;
            margin-top: 8px; padding-bottom: 10px;">
        <button mat-button class="command-button"
                (click)="searchButtonClicked()"
                matTooltipPosition="above"
                matTooltip="Search Cases"
                mat-button>
            <mat-icon>check_circle_outline</mat-icon>
            Search
        </button>
        <button mat-button class="command-button"
                matTooltipPosition="above"
                (click)="resetQueryCriteria()"
                matTooltip="Clear fields" mat-button>
            <mat-icon>highlight_off</mat-icon>
            Reset
        </button>
    </div>

    <div style="display: inline-block; text-align: right; width:33%;font-size:9pt">
        Results: {{pagination}}
    </div>

    <mat-divider style="padding-bottom: 5px;"> </mat-divider>
    <!-- Results Table -->
    <div>
        <div class="table-container mat-elevation-z1" style="height:290px; width:100%"
             (keydown)="tableKeyDown($event)" tabindex="-1">

            <table mat-table [dataSource]="dataSource" matSort
                   class="table-header-style-override"
                   (matSortChange)="onSortChange($event)">
                <!-- Select -->
                <ng-container matColumnDef="select">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                        class="table-header-style-override" style="width: 5px;">
                        <mat-checkbox (click)="$event.stopPropagation()"
                                      (change)="toggleAllSelected($event)"></mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let element;let tableRowIdx = index;"
                        style="width:5px !important;">
                        <mat-checkbox (click)="$event.stopPropagation();"
                                      (change)="runChecked($event)"
                                      [disabled]="false"
                                      [value]="element.select" [(ngModel)]="element.select" >
                        </mat-checkbox>
                    </td>
                </ng-container>

                <!-- Case Number -->
                <ng-container matColumnDef="caseNumber">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                        class="table-header-style-override"
                        style="width: 80px;">Case #
                    </th>
                    <td mat-cell
                        class="table-detail-style-override"
                        *matCellDef="let element;let tableRowIdx = index;">
                        {{element.caseNumber}}</td>
                </ng-container>

                <!-- First Name -->
                <ng-container matColumnDef="caseName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                        class="table-header-style-override"
                        style="width: 150px;">Case Name
                    </th>
                    <td mat-cell
                        class="table-detail-style-override"
                        *matCellDef="let element;let tableRowIdx = index;">
                        {{element.caseName}}</td>
                </ng-container>

                <ng-container matColumnDef="gender">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                        class="table-header-style-override"
                        style="width: 150px;">Gender
                    </th>
                    <td mat-cell
                        class="table-detail-style-override"
                        *matCellDef="let element;let tableRowIdx = index;">
                        {{element.gender}}</td>
                </ng-container>

                <!-- Request Type -->
                <ng-container matColumnDef="serviceRequestDesc">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                        class="table-header-style-override"
                        style="width: 150px;">Request Type
                    </th>
                    <td mat-cell
                        class="table-detail-style-override"
                        *matCellDef="let element;let tableRowIdx = index;">
                        {{element.serviceRequestDesc}}</td>
                </ng-container>

                <!-- Match Agency -->
                <ng-container matColumnDef="agencyName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                        class="table-header-style-override"
                        style="width: 190px;">Agency
                    </th>
                    <td mat-cell
                        class="table-detail-style-override"
                        *matCellDef="let element;let tableRowIdx = index;">
                        {{element.agencyName}}</td>
                </ng-container>

                <!-- Date -->
                <ng-container matColumnDef="dateReference">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                        class="table-header-style-override"
                        style="width: 80px;">Date Reference
                    </th>
                    <td mat-cell
                        class="table-detail-style-override"
                        *matCellDef="let element;let tableRowIdx = index;">
                      <span *ngIf="searchQBE.useDate=== 'created' ">  {{element.dateCreated | date:'mediumDate':'EST'}} </span>
                      <span *ngIf="searchQBE.useDate=== 'completed' ">  {{element.dateClosed | date:'mediumDate':'EST'}} </span>
                      <span *ngIf="searchQBE.useDate=== 'lastModified' ">  {{element.dateModified | date:'mediumDate':'EST'}} </span>
                        
                     </td>
                </ng-container>

                <ng-container matColumnDef="dateOfBirth">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                        class="table-header-style-override"
                        style="width: 80px;">DOB
                    </th>
                    <td mat-cell
                        class="table-detail-style-override"
                        *matCellDef="let element;let tableRowIdx = index;">
                        {{lblShowDate(element.dateOfBirth)}}</td>
                </ng-container>

                <!-- Case Status -->
                <ng-container matColumnDef="caseStatus">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                        class="table-header-style-override"
                        style="width: 100px;">Status
                    </th>
                    <td mat-cell
                        class="table-detail-style-override"
                        *matCellDef="let element;let tableRowIdx = index;">
                        {{element.caseStatus}}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row
                    *matRowDef="let row; columns: displayedColumns; let tableRowIdx = index;"
                    [ngClass]="{'row-selected': tableRowIdx == Idx}"
                    (click)="onRowClicked(row)" >
                </tr>
            </table>
            <app-dw-spinner [visible]="busyCursor"></app-dw-spinner>
            <div class="no-records-found" [hidden]="!noRecordsReturned">No
                Records Found</div>
        </div>
    </div>
    <!----------------------->
    <!-- ERROR LINE --------->
    <!----------------------->

     <div class="error-line" [hidden]='!strErr.length'
         style="text-align:left; bottom:60px; left: 22px;">{{strErr}}</div>
    <!----------------------->
    <!-- SAVE STRIP        -->
    <!----------------------->
    <div style="text-align:center; margin-top: 40px;">
        <button mat-button class="command-button" [disabled]="!enableSubmit"
                (click)="onSubmitClicked()" matTooltip="Submit / save this entry"
                mat-button>
            <mat-icon>check_circle_outline</mat-icon>
            Select
        </button>
        <button mat-button class="command-button"
                (click)="onCancelClicked()" matTooltip="Cancel without saving this entry" mat-button>
            <mat-icon>highlight_off</mat-icon>
            Cancel
        </button>
    </div>
</div>
